import { ACTION_TYPES } from '@app-types/simulator/simulator';

type FamilleVenteTypeApi = {
    idFamilleVente: string;
    libelleFamilleVente: string;
};

export type OffreCibleTypeApi = {
    _type: string;
    famillesVente: FamilleVenteTypeApi[];
    idOffre: string;
    libelleCommercial: string;
    montantRemiseTTC: number;
    tarifHT: number;
    tarifRemiseHT: number;
    tarifRemiseTTC: number;
    tarifTTC: number;
    tauxTVA: number;
    univers: string;
    coutMigration: number;
    dateEffet: Date;
    dureeEngagement: {
        dateFinEngagement: Date;
        duree: number;
        uniteDuree: string;
    };
    position: number;
    action?: ACTION_TYPES;
    dureeApplication?: DureeApplicationApi;
    dateFinValidite?: Date;
    typeOffre: string;
};

export type OffrePrincipaleDetenueTypeApi = Partial<OffreCibleTypeApi>;
export type OffresSecondairesTypeApi = Partial<OffreCibleTypeApi>[];

export type SimulateDataTypeApi = {
    offrePrincipaleDetenue: OffrePrincipaleDetenueTypeApi;
    offresSecondairesDetenues: OffresSecondairesTypeApi;
    simulations: {
        offrePrincipaleCible: OffreCibleTypeApi;
        offresSecondairesCibles: OffresSecondairesTypeApi;
    }[];
};

export type GalliumDataStoreApi = {
    ops: string[];
    opSource: GalliumOffreApi;
    simulation: GalliumOffreApi[];
};

export type GalliumType = {
    [key: string]: GalliumDataStoreApi;
};

export type GalliumOffreApi = {
    idOffre?: string;
    libelleCommercial?: string;
    libelleSysteme?: string;
    familleVente?: FamilleVenteTypeApi[];
    tarifRecurrent?: TarifRecurrentApi;
    tarifMoinsRemise?: TarifMoinsRemiseApi;
    dureeOffre?: number;
    uniteDureeOffre?: string;
    dateFinValidite?: Date;
    dureeApplication?: DureeApplicationApi;
    remiseAvantage?: GalliumOffreApi[];
    message?: {
        type: string;
    }[];
};

export type TarifRecurrentApi = {
    tarifHT?: number;
    tarifTTC?: number;
    tauxTVA?: number;
};

export type TarifMoinsRemiseApi = {
    tarifTTC?: number;
    montantRemiseTTC?: number;
};

export type DureeApplicationApi = {
    duree: number;
    uniteDuree: string;
};

export type RefundType = {
    amount?: number;
    duration?: number;
    name?: string;
    untilDate?: Date | number;
};

export interface GalliumPrice {
    price?: number;
    promoPrice?: number;
    refund?: number;
    promoLabel?: string;
    refundsList?: RefundType[];
    refundsWithDate?: number;
}

export interface GalliumPriceArray {
    [key: number]: GalliumPrice;
}

export const GALIUM_DATA_STORAGE_KEY = 'galliumData';
export const GALLIUM_PRICES_STORAGE_KEY = 'galliumPrices';
export const GALLIUM_STATUS_STORAGE_KEY = 'galliumStatus';
